import { useEffect, useState } from "react";
import { MainContainer, ErrorCard, LoadingCard } from "../../components";
import { Button, Input, Card, CardBody, useDisclosure } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/clientApiSettingSlice";

const CreateClientApiSetting = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { isNewEntry, detailParams } = useSelector((state) => state.clientApiSetting)
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    Client_Name: "",
    Markup: "",
  });

  useEffect(() => {
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
      setFormData({
        Client_Name: detailParams.Client_Name,
        Markup: detailParams.Markup,
      })
    }
  }, [detailParams, isNewEntry])
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const { mutate: funAddUpdate, isPending, isError } = usePost({
    queryKey: "clientApiSettings",
    url: apiRoute.clientApiSetting.add_update,
    successMessage: "Client API setting saved successfully!",
    onSuccessTasks: () => {
      dispatch(resetDetailParams())
      navigate(linksUrl.clientApiEntry.apiEntryMaster);
    },
  });
  const { mutate: funChkClientName, } = usePost({
    queryKey: "clientNameDuplicateCheck",
    url: apiRoute.clientApiSetting.checkClientName,
    onSuccessTasks: (data) => {
      if (data && data.length > 0) {
        if (data[0].ref == 1) {
          toast.error("Client Name Exists Use Another One", {
            position: "top-center",
            "className": "toast-error",
          })
          setFormData({ ...formData, Client_Name: "" })
        }

      }
    }
  })
  // Function to generate API Key from clientCode + Client_Name
  const generateApiKey = (clientName) => {
    const apiKeyText = `${user.clientCode}${clientName}`;
    return apiKeyText
      .split("")
      .map((char) => char.charCodeAt(0))
      .join(""); // Concatenate ASCII values
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.Client_Name.trim()) {
      toast.warn("Client Name is required.");
      return;
    }

    const apiKey = generateApiKey(formData.Client_Name);

    funAddUpdate({
      data: {
        Client_Name: formData.Client_Name,
        Api_Key: isNewEntry ? apiKey : detailParams?.Api_Key,
        Markup: formData.Markup,
        db_user: user.username,
        rec_status: !isNewEntry ? 1 : 2
      },
    });
  };

  const handleBlur = (e) => {
    const {  value } = e.target
    if (value != "" && value != null) {
      funChkClientName({
        data: {
          client_name: value
        }
      })
    }
  }
  if (isPending) return <LoadingCard />;
  if (isError) return <ErrorCard />;
  return (
    <MainContainer
      pageName="Stock Upload API Key Setting"
      breadcrumbs={["Settings", "Stock Upload API Key"]}
      prevPage={{
        show: true,
        onClick: () => navigate(linksUrl.clientApiEntry.apiEntryMaster),
      }}
    >
      <Card className="p-6">
        <CardBody>
          <form onSubmit={handleSubmit} className="grid gap-4">
            <Input
              label="Client Name"
              name="Client_Name"
              value={formData.Client_Name}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              size="sm"
              isDisabled={isNewEntry ? false : true}
              variant="bordered"

              maxLength={10}
            />
            <Input
              label="Markup (%)"
              name="Markup"
              type="number"
              size="sm"
              variant="bordered"
              value={formData.Markup}
              onChange={handleChange}
            />
            <div className="flex gap-4 justify-center">
            <Button type="submit" color="primary" size="sm" isLoading={isPending}>
              Submit
            </Button>
            <Button type="submit" color="danger" size="sm" onPress={()=> navigate(linksUrl.clientApiEntry.apiEntryMaster)} >
              Cancle
            </Button>
            </div>
          </form>
        </CardBody>
      </Card>
    </MainContainer>
  );
};

export default CreateClientApiSetting;
